module.exports = __webpack_public_path__ + "img/rewards99.6f4289b.svg";